// extracted by mini-css-extract-plugin
export default {"campusInfo":"ProgramSelect_campusInfo__cxqKc","labelWrapper":"ProgramSelect_labelWrapper__i4Up+"};